export default function OverlapLegend({ pt_name }) {
  const legends = [
    { name: "Cases", color: "black" },
    {
      name: `Genetically-related cases`,
      color: "purple",
    },
    { name: "No sequencing data", color: "grey" },
  ];

  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingBottom: '10px' }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          flexWrap: "wrap",
          justifyContent: "center",
          width: "auto",
          fontSize: 12,
        }}
      >
        {legends.map((legend, index) => (
          <div
            key={index}
            style={{ display: "flex", alignItems: "center", marginRight: "20px" }}
          >
            <span
              style={{
                display: "inline-block",
                width: "7px",
                height: "7px",
                borderRadius: "50%",
                backgroundColor: legend.color,
                marginRight: "10px",
              }}
            ></span>
            <span style={{ color: legend.color }}>{legend.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
